import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledButton } from './ReturnToSpringHealthButton.styles';

import { SPRING_HEALTH_RETURN_URLS } from '@/utils/springHealthUtils';

interface ReturnToSpringHealthButtonProps {
  product: string;
  fullWidth?: boolean;
  textKey?: string;
}

// Sends the member back to the product's program page in Spring Health.
const ReturnToSpringHealthButton: React.FC<ReturnToSpringHealthButtonProps> = ({
  product,
  fullWidth,
  textKey = 'coverage.spring_health.session_expired.button_text',
}) => {
  const { t } = useTranslation();

  const handleReturnToSpringHealth = () => {
    window.location.href = SPRING_HEALTH_RETURN_URLS[product] || SPRING_HEALTH_RETURN_URLS.sleepio;
  };

  return (
    <StyledButton
      variant="contained"
      type="button"
      fullWidth={fullWidth}
      color="primary"
      onClick={handleReturnToSpringHealth}
      rounded
    >
      {t(textKey)}
    </StyledButton>
  );
};

export default ReturnToSpringHealthButton;
